import { Button, Col, Empty, Input, Row, Skeleton, Tabs } from 'antd';
import { Table } from 'ant-table-extensions'
import { useEffect, useState } from 'react'
import { Link, useNavigate, useLocation, useParams } from "react-router-dom";

import { recordError } from '../../utils/logService';

import service from '../../services/citizenScienceService';
import { FolderViewOutlined, SearchOutlined } from '@ant-design/icons';

import moment from "moment";

export default function ListProject({ hasUpdated = false, defaultStatus, statuses }) {
    const [pageSize, setPageSize] = useState(10);
    const [loading, setLoading] = useState(true);
    const [filteredData, setFilteredData] = useState([]);
    const [searchText, setSearchText] = useState("");
    const [projectLink, setProjectLink] = useState("project");
    const [viewStatus, setViewStatus] = useState("View");
    // const [statuses, setStatuses] = useState([]);
    const [selectedStatus, setSelectedStatus] = useState();
    let submittedStatus = defaultStatus.key;
    const [activeKey, setActiveKey] = useState(submittedStatus);
    const [projects, setProjects] = useState([]);
    const [firstRecord, setFirstRecord] = useState(0);
    const [total, setTotal] = useState(0);

    const [currentPage, setCurrentPage] = useState(1);
    const [isNotSearchable, setIsNotSearchable] = useState(true);
    const [isSearchedResults, setIsSearchedResults] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const params = useParams();
    
    const columns = [
        {
            title: "Project Name",
            dataIndex: "name",
            key: "name",
            sorter: (a, b) => a.name.localeCompare(b.name),
        },
        {
            title: "Host Organisation(s)",
            dataIndex: "hostOrganisation",
            key: "hostOrganisation",
        },
        {
            title: "Last update date",
            dataIndex: "lastModified",
            key: "lastModified",
            sorter: (a, b) => a.lastModified.localeCompare(b.lastModified),
        },
        {
            title: "Project Lead",
            dataIndex: "projectLead",
            key: "projectLead",
        },
        {
            title: "Review",
            dataIndex: "review",
            key: "6",
            render: (_, record, index) => {
                    const currentRecord = {
                    ...record,
                    index: index + 1,
                    currentPage: currentPage,
                    pageSize: pageSize,
            };
                return (
                    <>
                        <Link
                            to={`/${projectLink}/${record.key}`}
                            state={{ from: location.pathname, data: currentRecord }}
                        >
                            <Button type="primary" icon={<FolderViewOutlined />}></Button>
                        </Link>
                    </>
                );
            },
        },
    ];

    useEffect(() => {
        const selectedKey = parseInt(params?.status);
        
        if (!selectedKey) {
          navigate(`/project-management/status/${submittedStatus.toString()}`);
          getProjectsByStatus({
            max: pageSize,
            first: firstRecord,
            statusKey: submittedStatus,
          });
          return;
        }
        
        if (location.state) {
          const {
            currentPage: cPage,
            pageSize: pSize,
          } = location.state;
    
        const keepCurrentPage = pageSize === pSize;
        const first = keepCurrentPage ? (cPage - 1) * pageSize : (cPage - 1) * pSize;
        setPageSize(pSize);
        setCurrentPage(cPage);
        getProjectsByStatus({ statusKey: selectedKey, first: first, max: pSize, clearSearch: false });

        } 
        else {

          getProjectsByStatus({
            max: pageSize,
            first: firstRecord,
            statusKey: selectedKey,
          });
        }
        
      }, [statuses.length > 0, hasUpdated]);

    // const getProjects = async () => {
    //     try {
    //         setLoading(true);
    //         const response = await service.getProjectList();
    //         if (response && response.status === 200) {
    //             console.log("In")

    //             const sorted = response.sort((a, b) => a.lastModified.localeCompare(b.lastModified))
    //             console.log("Sorted Data: ", sorted)
    //             setFilteredData(sorted);
    //         } else {
    //             setFilteredData([]);
    //         }

    //     } catch (error) {
    //         recordError(error);
    //     }
    // }
    const onStatusChange = (key) => {

    const keyValue = statuses.find(status => status.key === key);
    setSelectedStatus(key);
    setActiveKey(key.toString());
    setProjectLink("project");
    getProjectsByStatus({ statusKey: keyValue.key });
    setFirstRecord(0);
    setCurrentPage(1);
    setSearchText("");
    
    navigate(`/project-management/status/${key}`);

    setSelectedStatus(key);
    if (keyValue.label === "In Review") {
        setViewStatus("Review");
    } else {
        setViewStatus("View");
    }
    };

    //? Not sure what was the intention for this function, will check with dev team
    const getProjectStatus = async () => {
        try {
            const response = await service.getProjectStatus();
            var statusData = [];
            if (response && response.status === 200) {
                const { data } = response;
                data.sort((a, b) => a.key - b.key);

                statusData = data.map((status) => ({
                    key: status.key,
                    label: status.value,
                }));

                setSelectedStatus(data[0].key);
                // setStatuses(statusData);
                getProjectsByStatus({ statusKey: data[0].key });
            }
            else {
                setSelectedStatus("");
            }
        } catch (error) {
            recordError(error);
        }
    };

    const getProjectsByStatus = async ({
        statusKey = 0,
        first = firstRecord,
        max = pageSize,
        searchValue = searchText,
        clearSearch = true
    }) => 
        {
        if (clearSearch) {
            setSearchText("");
            searchValue = null;
        }
        setTotal(0);
        var actualStatusKey = statusKey ?? selectedStatus;
        setSelectedStatus(actualStatusKey);
        setActiveKey(actualStatusKey);
        setLoading(true);

        try {

            if (statuses.length === 0) return;

            if (actualStatusKey || actualStatusKey > 0) {
                const statusExists = statuses?.filter((c) => c.key == actualStatusKey);

                if (statusExists.length == 0) {
                    // default it to submitted status instead of the invalid value entered by the user
                    actualStatusKey = submittedStatus;
                }
            } 
            else if (
            actualStatusKey < 1 ||
            actualStatusKey == null ||
            actualStatusKey == undefined ||
            isNaN(actualStatusKey)) {
                actualStatusKey = submittedStatus;
            }

            const response = await service.getProjectsByStatus({
                statusKey: actualStatusKey,
                first: first,
                max: max,
                text: searchValue,
            });

            if (response && response.status === 200) {
                const { data } = response;

                setTotal(data?.total);
                let projectData = data.results?.map((element) => ({
                    key: element.uuid.toString() + "x" + element.id,
                    name: element.name,
                    hostOrganisation: element.hostOrganisation,
                    lastModified: moment(element.lastModified, "YYYY-MM-DD").format("YYYY-MM-DD"),
                    projectLead: element.projectLead?.firstName + " " + element.projectLead?.lastname,
                    selectedStatus: statuses?.find((c) => c.key == actualStatusKey),

                }));

                setProjects(projectData);
                setFilteredData(projectData);

                setLoading(false);
            }
            else if (response && response.status === 204) {
                setLoading(false);
                setProjects([]);
                setFilteredData([]);
            }
            else {
                setProjects([]);
                setFilteredData([]);
            }
            setLoading(false);
        } 
        catch (error) {
            recordError(error);
        }

        setIsSearchedResults(searchValue !== null && searchValue !== undefined && searchValue !== "");
        // navigate(`/project-management/status/${actualStatusKey.toString()}`);

    };
    
    const onPageChange = (page, size) => {
        const keepCurrentPage = pageSize === size;
        const first = keepCurrentPage ? (page - 1) * pageSize : 0;
        const newPage = keepCurrentPage ? page : 1;
        setFirstRecord(first);
        setPageSize(size);
        setCurrentPage(newPage);

        const selectedKey = parseInt(params?.status);
        setSelectedStatus(selectedKey);
        getProjectsByStatus({
            first: first,
            max: size,
            clearSearch: false,
            statusKey: selectedKey,
        });
    }
    const handleInputChange = (e) => {
        const { value: searchValue } = e.target;
        setSearchText(searchValue);
        setIsNotSearchable(searchValue.length === 0);

        if (searchValue === "" && isSearchedResults) {
            const selectedKey = parseInt(params?.status);

            setFirstRecord(0);
            setCurrentPage(1);
            getProjectsByStatus({ statusKey: selectedKey, searchValue: searchValue, clearSearch: false, first: 0 });
        }
    };

    const handleSearchRequest = async () => {
        // Do nothing if searchText is empty on hitting enter
        if (searchText.length > 0) {
            const selectedKey = parseInt(params?.status);

            setFirstRecord(0);
            getProjectsByStatus({ statusKey: selectedKey, first: 0, clearSearch: false });
            setIsSearchedResults(true);
        }
    };

    const onShowSizeChange = (page, size) => {
    const keepCurrentPage = pageSize === size;
    const first = keepCurrentPage ? (page - 1) * pageSize : 0;
    const newPage = keepCurrentPage ? page : 1;

    setPageSize(size);
    setCurrentPage(newPage);
  };

  const onRowChange = (row) => {
    setPageSize(row.pageSize);
  };

    return (
        <div className='content'>
            <Col xs={24}>
                <h1 className="center-align">Project List</h1>
            </Col>
            <div>List of Projects</div>
            <Row>
                <Col xs={16} sm={16} md={8}>
                    <Input
                        placeholder="Search Projects"
                        type="text"
                        className="search-bar"
                        onChange={handleInputChange}
                        onPressEnter={handleSearchRequest}
                        onPaste={handleInputChange}
                        value={searchText}
                        allowClear
                        size="large"
                        prefix={<SearchOutlined />}
                    />
                </Col>
                <Col xs={8} sm={8} md={8}>
                    <Button
                        disabled={isNotSearchable}
                        key="Search"
                        value="Search"
                        type="primary"
                        onClick={handleSearchRequest}
                        style={{ marginLeft: 10 }}
                    >
                        Search
                    </Button>
                </Col>
            </Row>
            <div className="space"></div>
            <Tabs
                className="citi-status-tabs"
                type="card"
                onChange={onStatusChange}
                items={statuses}
                activeKey={activeKey}
                defaultActiveKey={submittedStatus}
                key="1" />

            <Table
                // dataSource={loading ? [] : filteredData}
                dataSource={filteredData}
                locale={{
                    emptyText: loading ? <Skeleton active={true} /> : <Empty />,
                }}
                rowKey={(record) => "row-" + record.key}
                columns={columns}
                bordered
                loading={loading}
                onChange={onRowChange}
                pagination={{
                    defaultCurrent: 1,
                    current: currentPage,
                    defaultPageSize: pageSize,
                    total: total,
                    pageSize: pageSize,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    onChange: onPageChange,
                    onShowSizeChange: onShowSizeChange,
                    pageSizeOptions: [2, 5, 10, 20, 50, 100],
                    showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} ${total > 1 ? 'Projects' : 'Project'}`,
                }}
                size="middle"
                key="2"
            // exportableProps={{ showColumnPicker: true, fileName : 'My Data'}}
            />
        </div>
    )
}
